import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import moment from "moment";
import AkodeAccountBalanceTableFilter from "../Filters/AkodeAccountBalanceTableFilter";
import { ColumnHelper } from "util/TableHelper";

import { Table, Empty, Col, Row, Tooltip, message } from "antd";
import { BarsOutlined, FileExcelOutlined } from "@ant-design/icons";
import config from "../../util/ApiforContext";

const AccountTransaction = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });

  useEffect(() => getTableData(), [tableDataQueryOptions]);

  const getFilterQuery = () => {
    const { filter } = tableDataQueryOptions;

    const conditions = [];
    let query = "";

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = "$filter=" + conditions.join(" and ");
    }
    return query;
  };

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    const { skip, take } = tableDataQueryOptions;

     RequestHandler.get(
       `/ToslaAccountBalance?$count=true&${getFilterQuery()}&$skip=${skip}&$top=${take}`
     ).then((response) => {
       setTableData({
         data: response.value,
         total: response["@odata.count"],
         loading: false,
       });
     });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const onClickExportExcel = () => {
     const hideMessage = message.loading("Excel indiriliyor...", 0);

      RequestHandler.post(
        `/ToslaAccountBalance/ExportExcel`,
        {
          query: getFilterQuery(),
        },
        false
      ).then((response) => {
        hideMessage();
        if(response) {
          const base64String = response.base64;

          // Base64 verisini binary'e çevir
          const byteCharacters = atob(base64String);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
    
          // Blob oluştur
          const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
          // URL oluştur
          const url = URL.createObjectURL(blob);
    
          // İndirme işlemini başlat
          const a = document.createElement('a');
          a.href = url;
          a.download = response.fileName; // İndirilmiş dosyanın ismi
          document.body.appendChild(a);
          a.click();
    
          // Temizlik
          URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }
       
      });
  };

  const tableColumns = [
    {
      title: "Tarih",
      dataIndex: "date",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Versiyon",
      dataIndex: "version",
    },
    {
      title: "Eski Bakiye",
      dataIndex: "oldBalance",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Tutar",
      dataIndex: "amount",
      render: (data, row, index) => <p><>{row.debtOrCredit === "B" ? "-" + data.toLocaleString("tr-TR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }): data.toLocaleString("tr-TR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}</></p>,
    },
    {
      title: "Yeni Bakiye",
      dataIndex: "newBalance",
      render: ColumnHelper.renderDecimal,
    },
  ];

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> HESAP BAKİYELERİ
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>

      <AkodeAccountBalanceTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={tableColumns.filter((column) => !column.isRowDetail)}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            expandable={{
              expandedRowRender: record => <p style={{ margin: 0 }}> <strong>Hash Code : </strong>{record.currentHashCode}</p>
            }}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>
    </>
  );
};

export default AccountTransaction;
